import { modelValid } from "../modelSystemG";


export async function  validService(user){
    
    return  await modelValid({
        data:{
            collection: "service",
            data: ["admins", "array-contains", { email: user }],
          },
        doc:'Search'
    });
}

    